module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-oyster-fluted-balmoral-0.1cab3b0e.jpg";